// 仮申込に関するエラーページ
import RelatedTmpOrder from "@/pages/errorPage/RelatedTmpOrder";

// パスワード設定に関するエラーページ
import RelatedPasswordSetting from "@/pages/errorPage/RelatedPasswordSetting";

export default [
  {
    path: "/related_tmp_order",
    name: "RelatedTmpOrder",
    component: RelatedTmpOrder,
    meta: {
      noindex: true,
      title: 'エラー - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true,
  },
  {
    path: "/related_password_setting",
    name: "RelatedPasswordSetting",
    component: RelatedPasswordSetting,
    meta: {
      noindex: true,
      title: 'エラー - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true,
  }
]